import { CircularProgress } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./ReferralMobileChat.module.css";

export default function ReferralMobileChat({ chatId }: { chatId: string }) {
    const [isChatLoading, setIsChatLoading] = useState(true)
    const iframeSrc = `https://yandex.ru/drive/referral_chat/index.html?chat=${chatId}`;
    const history = useHistory();

    useEffect(() => {
        window.addEventListener("message", (event) => {
            switch (event.data) {
                case "close_referral":
                    history.goBack();
                    break;
                case "content_loaded":
                    setIsChatLoading(false);
                    break;
                default:
                    break;
            }
        }, false);

        window.visualViewport?.addEventListener("resize", (_) => {
            console.log("------");
            console.log(getComputedStyle(document.documentElement).getPropertyValue("--sab"));
            console.log("------");
        });
    }, []);

    return <div className={styles.container}>
        {
            isChatLoading &&
            <div className={styles.frame}>
                <div>
                    <CircularProgress />
                </div>
            </div>
        }
        <iframe key={"forever_keep"} className={styles.frame} src={iframeSrc} />
    </div>
}